import { ShieldOff } from "lucide-react";
import * as React from "react";
import { cn } from "../lib/utils.js";

/**
 * ValueAtRisk (W-3): "{value} unprotected" on a Not covered item. Red only
 * on the shield-off icon; the text stays in the heading colour, so the copy
 * carries the meaning. The label arrives translated and formatted.
 */

export interface ValueAtRiskProps extends React.ComponentProps<"p"> {
  label: string;
}

function ValueAtRisk({ label, className, ...props }: ValueAtRiskProps) {
  return (
    <p
      data-slot="value-at-risk"
      className={cn("inline-flex items-center gap-1.5 text-sm font-semibold text-foreground", className)}
      {...props}
    >
      <ShieldOff aria-hidden="true" className="size-4 shrink-0 text-status-error" />
      <span>{label}</span>
    </p>
  );
}

export { ValueAtRisk };
